<template>
    <kgr-form-scaffold
        :pending="pending"
        @primaryBtnClicked="createTeam"
        @backBtnClicked="redirectToOverview"
    >
        <kgr-department-data-provider
            :department-id="departmentId"
            :callback="onDepartmentLoaded"
        >
            <div class="animated fadeIn">
                <kgr-team-basic-data-form
                    v-if="team"
                    :team="team"
                    :club-id="clubId"
                    :error="error"
                    :hide-department-select="true"
                    :hide-image-upload="true"
                    @enter="createTeam"
                />
            </div>
        </kgr-department-data-provider>
    </kgr-form-scaffold>
</template>

<script>
import DepartmentDataProvider from '../../components/data-provider/DepartmentDataProvider';
import Error from '../../js/model/Error';
import FormScaffold from '../../components/common/form/FormScaffold';
import KgrTeamBasicDataForm from '../../components/team/TeamBasicDataForm';
import Team from '../../js/dto/Team';
import TeamRepository from '../../js/repository/TeamRepository';

export default {
    components: {
        KgrTeamBasicDataForm,
        'kgr-department-data-provider': DepartmentDataProvider,
        'kgr-form-scaffold': FormScaffold,
    },
    props: {
        overviewUrl: {
            type: String,
            required: true,
        },
        departmentId: {
            type: Number,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            pending: false,
            department: null,
            team: null,
            error: new Error(),
        };
    },
    methods: {
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        onDepartmentLoaded(loadedDepartment) {
            this.department = loadedDepartment;
            this.team = Team.create(loadedDepartment.id, loadedDepartment.name);
        },
        createTeam() {
            if (!this.team) {
                return;
            }

            this.pending = true;

            TeamRepository
                .create(this.departmentId, this.team)
                .then(() => {
                    this.$notify.success('Team erfolgreich erstellt', {}, { saveInSession: true });
                    this.redirectToOverview();
                })
                .catch((error) => {
                    this.error = error;
                    this.$notify.error('saveChanges.error');
                    this.pending = false;
                });
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
